import { FunctionComponent } from 'react';

import AlternatingText from 'components/AlternatingText';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useActionRequired from './useActionRequired';

const ActionRequired: FunctionComponent = () => {
  const { isLoading, provider } = useActionRequired();

  return (
    <>
      <PleaseWaitOverlay
        icon="error"
        iconClassName="!text-lavender-300 mb-4"
        title="The lender has asked for some supporting information"
        labelLine1={
          <AlternatingText
            array={[
              'You will have received an email from our lender, ',
              provider,
              ' asking for some more information.',
            ]}
          />
        }
        labelLine2="The will have sent you a link via email that you can use to upload the requested documents."
        labelLine3={
          <p>
            If you&apos;re having trouble, you can reach out to Ideal4Finance
            loans team directly by clicking the{' '}
            <span className="font-semibold">&quot;Need Help&quot;</span> button
            in the header and calling our loans applications team to get some
            advice.
          </p>
        }
        isLoading={isLoading}
      />
    </>
  );
};

export default ActionRequired;
